    //global
    let duration = 4000;
    let nowPlaying = false;
    let validDate = '2030-12-26'
    //func 表示のセット
    const isDateValid = (dateStr)=>{
      const date = new Date(dateStr);
      const nowDate = new Date();
      if(nowDate <= date){
        return true
      }
      return false
    }
    //func 初回訪問判別のcookieセット
    const setVisited = ()=>{
      document.cookie = "is_visited=true; max-age=60; path=/";
    }
    //func cookie初回訪問判別
    const isVisited = ()=>{
      if(document.cookie.indexOf("is_visited") == -1){
        return false
      }else{
        return true
      }
    }
    //func 音楽再生
    const playAudio = ()=>{
        nowPlaying = true
        //再生時間を延長
        const audio = document.querySelector("#audio")
        audio.play()
    }
    //func 音楽停止
    const stopAudio = ()=>{
        const audio = document.querySelector("#audio")
        audio.pause()
    }
    //func geturl
    const getPathNameArr = ()=>{
      const url = new URL(window.location.href)
      const arr = url.pathname.split("/")
      return arr
    }
    //func skip loagingを消してtopページを表示
    const skipLoading = ()=>{
      if(!isVisited()){
        setVisited()
      }
      const loadingElement = document.querySelector('.loading');
      loadingElement.style.transition = 'opacity 400ms ease-out';
      loadingElement.style.opacity = '0';
      setTimeout(function() {
          loadingElement.style.display = 'none';
      }, 400); // transitionの時間に合わせる
    }
    //func fadeout anime
    const fadeOutProcess = (elm)=>{
      // fadeOut() に相当する処理
      // opacityを transitionでアニメーションさせてから display: 'none' にする
      elm.style.transition = 'opacity 400ms ease-out';
      elm.style.opacity = '0';
      // アニメーション完了後に要素を完全に非表示にする
      // transitionの時間を考慮してsetTimeoutを設定
      setTimeout(function() {
          elm.style.display = 'none';
      }, 400); // transitionの時間に合わせる
      //音楽をなっているかもしれないので消す
      //stopAudio()
      //訪問を設定
      if(!isVisited()){
        setVisited()
      }
    }
    //func setTimeout
    const execSetTimeout = (ms)=>{
      return setTimeout(function() {
        const elm = document.querySelector(".loading")
        if (elm) {
          fadeOutProcess(elm)
        }
      }, ms); // duration秒の遅延
    }

    /**
     * 再生ボタンのイベント割り当て
     * 初回訪問判別(cookie使用) url判別でloading判別
     * 
     */
    window.addEventListener("DOMContentLoaded", function(){
      //event 再生ボタンをクリックしたら再生する
      //document.getElementById("play").addEventListener("click", function(){
      //  playAudio()
      //})
      //document.getElementById("play-stop").addEventListener("click", function(){
      //  stopAudio()
      //})
      this.document.querySelector(".skip").addEventListener("click",function(){
        skipLoading()
      })
      //loadigの子要素はdefault非表示にしている
      //親要素のloadingは表示している
      //訪問済みだったら親要素のloadingを表示させない(domから消す)
      //またtopページ以外もloadingを表示させない(pathArr[1]!=="")
      const pathArr = getPathNameArr()
      const loadingElement = document.querySelector('.loading');
      if(isVisited() || pathArr[1]!== ""){
        loadingElement.style.opacity = '0';
        loadingElement.style.display = 'none';
      }
      //初回訪問はなにもしない
      if(!isVisited()){ return; }
      //topページはなにもしない
      if(pathArr[1]===""){ return; }
      /*** load eventに続く ***/
    })

    window.addEventListener('load', function() {
        //有効期限前は何もしない
        if(!isDateValid(validDate)){return;}
        //cookie-visitedがあれば訪問済みなのでloadingしない
        if(isVisited()){ return; }
        //topページはloadingしない
        const pathArr = getPathNameArr()
        if(pathArr[1] !== "") { return; }
        /* invisibleにクラスをあてて表示する */
        const showElm = document.querySelector(".invisible");
        showElm.className = "visible-elm"

        // '.loading' を非表示にする ( fadeout() )
        const loadingElement = document.querySelector('.loading');
        setTimeout(function() {
          if (loadingElement) {
            fadeOutProcess(loadingElement)
          }
        }, duration); // duration秒の遅延
      });